/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WindroseDirectionBucket } from './WindroseDirectionBucket';
import {
    WindroseDirectionBucketFromJSON,
    WindroseDirectionBucketFromJSONTyped,
    WindroseDirectionBucketToJSON,
    WindroseDirectionBucketToJSONTyped,
} from './WindroseDirectionBucket';

/**
 * 
 * @export
 * @interface WindroseDataRepresentation
 */
export interface WindroseDataRepresentation {
    /**
     * 
     * @type {Array<WindroseDirectionBucket>}
     * @memberof WindroseDataRepresentation
     */
    directionBuckets?: Array<WindroseDirectionBucket>;
}

/**
 * Check if a given object implements the WindroseDataRepresentation interface.
 */
export function instanceOfWindroseDataRepresentation(value: object): value is WindroseDataRepresentation {
    return true;
}

export function WindroseDataRepresentationFromJSON(json: any): WindroseDataRepresentation {
    return WindroseDataRepresentationFromJSONTyped(json, false);
}

export function WindroseDataRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WindroseDataRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'directionBuckets': json['directionBuckets'] == null ? undefined : ((json['directionBuckets'] as Array<any>).map(WindroseDirectionBucketFromJSON)),
    };
}

export function WindroseDataRepresentationToJSON(json: any): WindroseDataRepresentation {
    return WindroseDataRepresentationToJSONTyped(json, false);
}

export function WindroseDataRepresentationToJSONTyped(value?: WindroseDataRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'directionBuckets': value['directionBuckets'] == null ? undefined : ((value['directionBuckets'] as Array<any>).map(WindroseDirectionBucketToJSON)),
    };
}

